import { createReducer } from '@reduxjs/toolkit';
import {
  fetchFamiliesFailed,
  fetchFamiliesStarted,
  fetchFamiliesSucceeded,
  fetchMakesFailed,
  fetchMakesStarted,
  fetchMakesSucceeded,
  fetchVariantsFailed,
  fetchVariantsStarted,
  fetchVariantsSucceeded,
  fetchVehiclesFailed,
  fetchVehiclesStarted,
  fetchVehiclesSucceeded,
  setAttachments,
  setFamilies,
  setMakes,
  setVariants,
  setVehicles,
} from '../../actions/vehicle_link';

export const initialState = {
  segments: [],
  makes: {},
  families: {},
  vehicles: {},
  variants: {},
  attachments: [],
  fetchingStatus: {
    makes: false,
    families: false,
    vehicles: false,
    variants: false,
  },
};

const VehicleLinkReducer = createReducer(initialState, {
  [fetchMakesStarted]: (state) => {
    state.fetchingStatus.makes = true;
  },

  [fetchMakesSucceeded]: (state) => {
    state.fetchingStatus.makes = false;
  },

  [fetchMakesFailed]: (state) => {
    state.fetchingStatus.makes = false;
  },

  [setMakes]: (state, action) => {
    const { code, makes } = action.payload;

    state.makes[code] = makes;
  },

  [fetchFamiliesStarted]: (state) => {
    state.fetchingStatus.families = true;
  },

  [fetchFamiliesSucceeded]: (state) => {
    state.fetchingStatus.families = false;
  },

  [fetchFamiliesFailed]: (state) => {
    state.fetchingStatus.families = false;
  },

  [setFamilies]: (state, action) => {
    const { cacheKeyName, families } = action.payload;

    state.families[cacheKeyName] = families;
  },

  [fetchVehiclesStarted]: (state) => {
    state.fetchingStatus.vehicles = true;
  },

  [fetchVehiclesSucceeded]: (state) => {
    state.fetchingStatus.vehicles = false;
  },

  [fetchVehiclesFailed]: (state) => {
    state.fetchingStatus.vehicles = false;
  },

  [setVehicles]: (state, action) => {
    const { params, vehicles } = action.payload;
    const cacheKeyName = `${params.code}_${params.makeCode}_${params.familyCode}_${params.bodyStyleCode}`;

    state.vehicles[cacheKeyName] = vehicles;
  },

  [fetchVariantsStarted]: (state) => {
    state.fetchingStatus.variants = true;
  },

  [fetchVariantsSucceeded]: (state) => {
    state.fetchingStatus.variants = false;
  },

  [fetchVariantsFailed]: (state) => {
    state.fetchingStatus.variants = false;
  },

  [setVariants]: (state, action) => {
    const { cacheKeyName, variants } = action.payload;

    state.variants[cacheKeyName] = variants;
  },

  [setAttachments]: (state, action) => {
    state.attachments = action.payload;
  },
});

export default VehicleLinkReducer;
